export enum Step {
  One = 'one',
  Two = 'two',
  Three = 'three',
};

export const MODEL_ERROR_CODE = [52000, 52001, 52002, 52003, 52004, 52005, 52006, 10010, 20001, 21002];

/** tea-notification 根节点 className，与 index.scss 中宽度配套（挂到 body） */
export const YAML_TEST_RESULT_NOTIFICATION_CLASS =
  'dbl-model-yaml-test-result-notification';

/** 测试失败反馈通知：在基础 class 上叠加，用于样式（如标题黑色） */
export const YAML_TEST_FAILURE_NOTIFICATION_CLASS = `${YAML_TEST_RESULT_NOTIFICATION_CLASS} dbl-model-yaml-test-result-notification--failure`;